import { useApiPostRequest } from '@/api/rest/hooks/useApiPostRequest';

import {
  POST_INDICATOR_PRODUCT_SUBSCRIBE_PATH,
  PostIndicatorProductSubscribeBodyData,
  PostIndicatorProductSubscribeErrorDto,
  PostIndicatorProductSubscribeRequestPathVariables,
  PostIndicatorProductSubscribeRequestQueryParams,
  PostIndicatorProductSubscribeSuccessDto,
} from './types/IndicatorProduct';

export const useIndicatorProductSubscribe = () => {
  return useApiPostRequest<
    PostIndicatorProductSubscribeRequestPathVariables,
    PostIndicatorProductSubscribeRequestQueryParams,
    PostIndicatorProductSubscribeBodyData,
    PostIndicatorProductSubscribeSuccessDto,
    PostIndicatorProductSubscribeErrorDto
  >(POST_INDICATOR_PRODUCT_SUBSCRIBE_PATH);
};
